import React from 'react';
import styled from 'styled-components';

export const LayoutButton = styled.div`
  width: 300px;
  min-height:92px;
  padding:1rem;
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  display: grid;
  justify-content: center;
  align-content: center;
  text-align: center;
  user-select: none;
  cursor: pointer;
  &:hover {
    box-shadow: 0 4px 6px 0 #082e5f;
  }

  p.preguntas_frecuentes {
    color: #2186f6;
    margin: auto;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledButtonVerMas = styled.button`
  font-size: 1.5rem;
  color: #2186f6;
  border: none;
  outline: none !important;
  background-color: #ffffff;
  &:hover {
    border-bottom: 1px solid #2186f6;
  }
`;

export const ImpuestoValue = styled.div`
font-size: 1.2rem;
color: #133861;
`;
// display: grid;
// justify-content: center;
// align-content: center;
// align-items: center;
export const ImpuestoLabel = styled.div`
  font-size: 1.1rem;
  color: #949494;
`;

export const Layout: React.FC<any> = ({ children, onClick }) =>
  <div
    className="col-10 col-sm-6 col-md-10 col-lg-6 col-xl-4 align-self-center my-3"
    style={{ display: 'grid', justifyContent: 'center', alignContent: 'center' }}
  >
    <LayoutButton onClick={onClick}>{children}</LayoutButton>
  </div>

